const host = process.env.REACT_APP_WS_HOST

export default host
